import { TLocalization } from 'shared/types'
import { api } from '..'

export const setDeviceLocalization =
  (deviceId: string) =>
  ({ locationId, ...data }: TLocalization) => {
    const localization = Object.entries(data).reduce(
      (prev: Record<string, string>, [key, value]) => {
        if (value) prev[key] = value.toString()
        return prev
      },
      {},
    )

    return Promise.all([
      api.put(`/v1/devices/${deviceId}/localization`, localization),
      api.put(`/v1/devices/${deviceId}/location`, { locationId }),
    ])
  }
